import {} from "../env/index.js";
import {} from "../mod/index.js";
import { createNet } from "../net/createNet.js";
import {} from "../net/index.js";
export function createEnv(mod, options) {
    return {
        mod,
        net: (options === null || options === void 0 ? void 0 : options.net) || createNet(),
        stack: [],
        locals: new Map(),
    };
}
//# sourceMappingURL=createEnv.js.map